import { useEffect, useRef } from "react";
import { subscribeMesfRealtime } from "../services/mesfRealtimeConnection";

type Props = {
	onReceiveMessage: (author: string, message: string) => void;
};
export const useMesfRealtime = ({ onReceiveMessage }: Props) => {
	const onReceiveMessageRef = useRef(onReceiveMessage);
	onReceiveMessageRef.current = onReceiveMessage;

	useEffect(() => {
		return subscribeMesfRealtime((author, message) => {
			onReceiveMessageRef.current(author, message);
		});
	}, []);
};
